export enum GaPageType {
    SHOPPINGBAG= 'shopping-bag',
    CHECKOUTSHIPPING='checkout-shipping',
    CHECKOUTPAYMENT='checkout-payment',
    ORDERCONFIRMATION='order-confirmation',
    MYACCOUNT='my-account',
    MYORDER='my-orders',
    ORDERDETAILS='order-details'
}